import { h } from 'preact';
import PropTypes from 'prop-types';

import SkeletonBlock from '../skeleton-block/skeleton-block';

const DEFAULT_MODIFIERS = ['label'];

const LabelSkeleton = ({ skeletonColor, modifiers = DEFAULT_MODIFIERS, tag }) => (
  <SkeletonBlock modifiers={modifiers} skeletonColor={skeletonColor} tag={tag} />
);

LabelSkeleton.propTypes = {
  skeletonColor: PropTypes.string.isRequired,
  modifiers: PropTypes.array,
  tag: PropTypes.string,
};

export default LabelSkeleton;
